import _ from 'underscore';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import EditorView from '@bingads-webui-campaign-legacy/adextension-price/view/extensionEditor';
import { convertCurrencyCode } from '@bingads-webui-campaign-legacy/adextension-price/utility';
import preview from '@bingads-webui-campaign-legacy/adextension-price/template/extensionPreview.pug';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';

const schema = window.globalLegacySchema.get('PriceAdExtension');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

const dialogOptions = {
  position: 'center',
  maxWidth: 1800,
};

const i18nKeys = {
  title: 'AdExtensions_Price_Editor_Title',
  subtitle: ['NewCampaign_PriceAdExtension_Subtitle'],
  /* eslint-disable */
  library_title: 'AdExtensions_Price_Editor_Available',
  selected_title: 'AdExtensions_Price_Editor_Selected',
  create_link: 'AdExtensions_Price_Editor_CreateNew',
  create_title: 'AdExtensions_Price_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Price_Editor_Delete',
  delete_confirm: 'AdExtensions_Price_Delete_Warning',
  edit_btn: 'AdExtensions_Price_Editor_Edit',
  edit_title: 'AdExtensions_Price_Dialog_Title_Edit',
  /* eslint-enable */
  inlineAlert: 'AdExtensions_Price_Max_Select_Notification',
};

const showItemCount = 3;

const View = AssociationsEditorBase.extend({
  initialize(options = {}) {
    const Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n,
      panelReadyAriaLabel: i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName,
    }) :
      dialogDecorator.decorate(EditorView, dialogOptions);

    _.extend(options, {
      idField: 'Id',
      data: new SharedRepository({
        schema,
        afterChangeComitted: () => {
          if (_.isFunction(options.updateContext)) {
            options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
          }
        },
      }),
      template: {
        preview,
      },
      maxSelectedItemsCount: 20,
      processItem: (item) => {
        if (_.size(item.TableRows) > showItemCount) {
          item.AdExtensionMoreInfo = i18n.get('PriceAdExtensions_Preview_And_More', { count: _.size(item.TableRows) - showItemCount });
        }
        _.each(item.TableRows, (row) => {
          row.PriceInfo = `${convertCurrencyCode(row.CurrencyCode)}${row.Price}`;
        });
        item.showItemCount = showItemCount;
        return item;
      },
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || {}),
      extensionType: 'PriceExtension',
    });

    AssociationsEditorBase.prototype.initialize.call(this, options);
  },
});

export default View;
